//#region Imports
import { Profile as MProfile } from "_modules/auth/pages";
import ChiTietCombo from "_modules/combo/pages/ChiTietCombo";
import ChiTietDeXuatCombo from "_modules/combo/pages/ChiTietDeXuatCombo";
import ComboItem from "_modules/combo/pages/ComboItem";
import DanhSachCombo from "_modules/combo/pages/DanhSachCombo";
import DanhSachDeXuatCombo from "_modules/combo/pages/DanhSachDeXuatCombo";
import SuaCombo from "_modules/combo/pages/SuaCombo";
import SuaDeXuatCombo from "_modules/combo/pages/SuaDeXuatCombo";
import ThemCombo from "_modules/combo/pages/ThemCombo";
import ThemDeXuatCombo from "_modules/combo/pages/ThemDeXuatCombo";
import DashboardPage from "_modules/dashboard/pages/DashboardPage";
import DanhSachDinhMucTonKhoPage from "_modules/dinh_muc_ton_kho/pages/DanhSachDinhMucTonKhoPage";
import {
  ExportCreate,
  ExportList,
  ExportPrint,
  ExportUpdate,
} from "_modules/export/pages";
import {
  BaoCaoDieuChinhGia as BaoCaoDieuChinhGiaNVL,
  CreateMaterialSuggest,
  Material as MaterialComponent,
  MaterialGroup,
  MaterialIndustryList,
  MaterialSuggest,
  MaterialType,
  MaterialUpdate,
  PurchaseSemiFinishedProductForm,
  PurchaseSemiFinishedProductsList,
  RawMaterialForm,
  RawMaterialsList,
  SemiFinishedProductForm,
  SemiFinishedProductsList,
  UpdateMaterialSuggest,
} from "_modules/goods/pages";
import {
  BaoCaoDieuChinhDinhMuc,
  BaoCaoDieuChinhGia,
  CreateDanhMucHangHoa,
  DeXuatGiaMatHang,
  DeXuatMatHang,
  DieuChinhDinhMucHangHoa,
  DieuChinhGiaHangHoa,
  DieuChinhThongTinHangHoa,
  MatHang,
  NganhHangHoa,
  NhomHangHoa,
  UpdateDanhMucHangHoa,
  XemChiTietHangHoa,
  XemDeXuatHangHoa,
} from "_modules/hang_hoa/pages";
import {
  ImportCreate,
  ImportList,
  ImportOutsideCreate,
  ImportOutsideList,
  ImportOutsideUpdate,
  ImportPrint,
  ImportUpdate,
} from "_modules/import/pages";
import {
  InventoryAdjustmentList,
  InventoryCancelList,
  InventoryCheck,
  InventoryCheckCreate,
  InventoryCheckUpdate,
  InventoryEndOfMonthCheck,
  InventoryEndOfMonthCheckCreate,
  InventoryEndOfMonthCheckUpdate,
  InventoryInstant,
  InventoryReturnCreate,
  InventoryReturnList,
  InventoryReturnUpdate,
  InventorySlip,
  PhieuHuyHang,
} from "_modules/inventory/pages";
import ChiTietMenu from "_modules/menu/pages/ChiTietMenu";
import DanhSachMenuPage from "_modules/menu/pages/DanhSachMenuPage";
import SuaMenuPage from "_modules/menu/pages/SuaMenuPage";
import TaoMenuPage from "_modules/menu/pages/TaoMenuPage";
import ChamDiemDeXuatNhaCungCap from "_modules/nha_cung_cap/pages/ChamDiemDeXuatNhaCungCap";
import DanhGiaDeXuatNhaCungCap from "_modules/nha_cung_cap/pages/DanhGiaDeXuatNhaCungCap";
import DanhSachDeXuatNhaCungCap from "_modules/nha_cung_cap/pages/DanhSachDeXuatNhaCungCap";
import DanhSachNhaCungCap from "_modules/nha_cung_cap/pages/DanhSachNhaCungCap";
import PhieuDeXuatNhaCungCap from "_modules/nha_cung_cap/pages/PhieuDeXuatNhaCungCap";
import {
  ApprovalConfiguration,
  ConfigurationPermission,
  ExportedMaterialConfig,
  GroupPermission,
  SlipPermission,
} from "_modules/permission/pages";
import DanhSachHangHoaChamDiem from "_modules/phieu_cham_diem_hang_hoa/pages/DanhSachHangHoaChamDiem";
import DanhSachPhieuChamDiemHangHoa from "_modules/phieu_cham_diem_hang_hoa/pages/DanhSachPhieuChamDiemHangHoa";
import HangHoaChamDiem from "_modules/phieu_cham_diem_hang_hoa/pages/HangHoaChamDiem";
import SuaPhieuChamDiemHangHoa from "_modules/phieu_cham_diem_hang_hoa/pages/SuaPhieuChamDiemHangHoa";
import ThemPhieuChamDiemHangHoa from "_modules/phieu_cham_diem_hang_hoa/pages/ThemPhieuChamDiemHangHoa";
import DanhSachNhaCungCapChamDiem from "_modules/phieu_cham_diem_nha_cung_cap/pages/DanhSachNhaCungCapChamDiem";
import DanhSachPhieuChamDiemNhaCungCap from "_modules/phieu_cham_diem_nha_cung_cap/pages/DanhSachPhieuChamDiemNhaCungCap";
import NhaCungCapChamDiem from "_modules/phieu_cham_diem_nha_cung_cap/pages/NhaCungCapChamDiem";
import PhieuChamDiemNhaCungCap from "_modules/phieu_cham_diem_nha_cung_cap/pages/PhieuChamDiemNhaCungCap";
import {
  PurchaseProposalFormCreate,
  PurchaseProposalFormList,
  PurchaseProposalFormPrint,
  PurchaseProposalFormUpdate,
  QuantitativeListPage,
  TransferCreatePage,
  TransferListPage,
  TransferUpdatePage,
} from "_modules/purchase_proposal_form/pages";
import {
  CancellationDetailSummary,
  CancellationSummary,
  ExportDetailSummary,
  ExportRawDetailSummary,
  ExportRawSummary,
  ExportSummary,
  ImportDetailSummary,
  ImportRawDetailSummary,
  ImportRawSummary,
  ImportSummary,
  InventoryAdjustmentSummary,
  InventorySummary,
  OrderSummary,
  TransferSummary,
} from "_modules/summary/pages";
import WarehouseListPage from "_modules/warehouse/pages/WarehouseListPage";

import {
  ChatLuongHangHoa,
  Combo,
  DeXuatNhaCungCap,
  Export,
  HangHoa,
  Import,
  Inventory,
  Material,
  Menu,
  NhaCungCap,
  Permission,
  Profile,
  Solution,
  Summary,
  Warehouse,
} from "./constant";
//#endregion

//#region Routes
const routes = [
  {
    exact: true,
    from: "/",
    redirect: Inventory.Slip.List.path,
  },

  //#region Báo cáo
  {
    ...Summary.Dashboard,
    exact: true,
    component: DashboardPage,
  },
  {
    ...Summary.Export,
    exact: true,
    component: ExportSummary,
  },
  {
    ...Summary.ExportDetail,
    exact: true,
    component: ExportDetailSummary,
  },
  {
    ...Summary.Import,
    exact: true,
    component: ImportSummary,
  },
  {
    ...Summary.Cancellation,
    exact: true,
    component: CancellationSummary,
  },
  {
    ...Summary.CancellationDetail,
    exact: true,
    component: CancellationDetailSummary,
  },
  {
    ...Summary.ImportDetail,
    exact: true,
    component: ImportDetailSummary,
  },
  {
    ...Summary.ImportRaw,
    exact: true,
    component: ImportRawSummary,
  },
  {
    ...Summary.ImportRawDetail,
    exact: true,
    component: ImportRawDetailSummary,
  },
  {
    ...Summary.ExportRaw,
    exact: true,
    component: ExportRawSummary,
  },
  {
    ...Summary.ExportRawDetail,
    exact: true,
    component: ExportRawDetailSummary,
  },
  {
    ...Summary.Inventory,
    exact: true,
    component: InventorySummary,
  },
  {
    ...Summary.InventoryAdjustment,
    exact: true,
    component: InventoryAdjustmentSummary,
  },
  {
    ...Summary.Order,
    exact: true,
    component: OrderSummary,
  },
  {
    ...Summary.Transfer,
    exact: true,
    component: TransferSummary,
  },
  //#endregion

  //#region Kiểm kho
  {
    ...Inventory.Check.List,
    exact: true,
    component: InventoryCheck,
  },
  {
    ...Inventory.Check.Create,
    exact: true,
    component: InventoryCheckCreate,
  },
  {
    ...Inventory.Check.Update,
    exact: true,
    component: InventoryCheckUpdate,
  },
  //#endregion

  //#region Kiểm kho cuối tháng
  {
    ...Inventory.EndOfMonthCheck.List,
    exact: true,
    component: InventoryEndOfMonthCheck,
  },
  {
    ...Inventory.EndOfMonthCheck.Create,
    exact: true,
    component: InventoryEndOfMonthCheckCreate,
  },
  {
    ...Inventory.EndOfMonthCheck.Update,
    exact: true,
    component: InventoryEndOfMonthCheckUpdate,
  },
  //#endregion

  //#region Danh sách tồn kho
  {
    ...Inventory.Slip.List,
    exact: true,
    component: InventorySlip,
    //#endregion
  },
  //#region Tồn kho tức thời
  {
    ...Inventory.Slip.Instant,
    exact: true,
    component: InventoryInstant,
  },
  //#endregion
  //#region Định mức tồn kho
  {
    ...Inventory.DinhMucTonKho.List,
    exact: true,
    component: DanhSachDinhMucTonKhoPage,
  },
  //#endregion
  //#region Điều chỉnh lượng tồn kho
  {
    ...Inventory.Adjustment.List,
    exact: true,
    component: InventoryAdjustmentList,
  },
  //#endregion

  //#region Trả hàng
  {
    ...Inventory.Return.List,
    exact: true,
    component: InventoryReturnList,
  },
  {
    ...Inventory.Return.Create,
    exact: true,
    component: InventoryReturnCreate,
  },
  {
    ...Inventory.Return.Update,
    exact: true,
    component: InventoryReturnUpdate,
  },
  //#endregion

  //#region Hủy hàng
  {
    ...Inventory.Cancel.List,
    exact: true,
    component: InventoryCancelList,
  },
  {
    ...Inventory.Cancel.Create,
    exact: true,
    component: PhieuHuyHang,
  },
  {
    ...Inventory.Cancel.Update,
    exact: true,
    component: PhieuHuyHang,
  },
  {
    ...Inventory.Cancel.Approval,
    exact: true,
    component: PhieuHuyHang,
  },
  //#endregion

  //#region Trả hàng
  {
    ...Inventory.Return.List,
    exact: true,
    component: InventoryReturnList,
  },
  {
    ...Inventory.Return.Create,
    exact: true,
    component: InventoryReturnCreate,
  },
  {
    ...Inventory.Return.Update,
    exact: true,
    component: InventoryReturnUpdate,
  },
  //#endregion

  //#region Xuất hàng
  {
    ...Export.List,
    exact: true,
    component: ExportList,
  },
  {
    ...Export.Create,
    exact: true,
    component: ExportCreate,
  },
  {
    ...Export.Update,
    exact: true,
    component: ExportUpdate,
  },
  {
    ...Export.Print,
    exact: true,
    component: ExportPrint,
  },
  //#endregion

  //#region Nhập hàng
  {
    ...Import.Material.List,
    exact: true,
    component: ImportList,
  },
  {
    ...Import.Material.Create,
    exact: true,
    component: ImportCreate,
  },
  {
    ...Import.Material.Update,
    exact: true,
    component: ImportUpdate,
  },

  {
    ...Import.Material.Print,
    exact: true,
    component: ImportPrint,
  },

  {
    ...Import.OutsideMaterial.List,
    exact: true,
    component: ImportOutsideList,
  },
  {
    ...Import.OutsideMaterial.Create,
    exact: true,
    component: ImportOutsideCreate,
  },
  {
    ...Import.OutsideMaterial.Update,
    exact: true,
    component: ImportOutsideUpdate,
  },
  //#endregion

  //#region Người dùng
  {
    ...Profile["_"],
    exact: true,
    component: MProfile,
  },
  //#endregion

  //#region Phiếu đề xuất
  {
    ...Solution.Quantitative,
    exact: true,
    component: QuantitativeListPage,
  },
  {
    ...Solution.List,
    exact: true,
    component: PurchaseProposalFormList,
  },
  {
    ...Solution.Create,
    exact: true,
    component: PurchaseProposalFormCreate,
  },
  {
    ...Solution.Update,
    exact: true,
    component: PurchaseProposalFormUpdate,
  },
  {
    ...Solution.Print,
    exact: true,
    component: PurchaseProposalFormPrint,
  },
  {
    ...Solution.Transfer,
    exact: true,
    component: TransferListPage,
  },
  {
    ...Solution.TransferCreate,
    exact: true,
    component: TransferCreatePage,
  },
  {
    ...Solution.TransferUpdate,
    exact: true,
    component: TransferUpdatePage,
  },
  //#endregion

  //#region Nguyên vật liệu
  {
    ...Material.Industry,
    exact: true,
    component: MaterialIndustryList,
  },
  {
    ...Material.Category,
    exact: true,
    component: MaterialGroup,
  },
  {
    ...Material.Type,
    exact: true,
    component: MaterialType,
  },
  {
    ...Material.Suggest,
    exact: true,
    component: MaterialSuggest,
  },
  {
    ...Material.CreateMaterialSuggest,
    exact: true,
    component: CreateMaterialSuggest,
  },
  {
    ...Material.UpdateMaterialSuggest,
    exact: true,
    component: UpdateMaterialSuggest,
  },
  {
    ...Material.PriceUpdateReport,
    exact: true,
    component: BaoCaoDieuChinhGiaNVL,
  },
  {
    ...Material.List,
    exact: true,
    component: MaterialComponent,
  },
  {
    ...Material.Update,
    exact: true,
    component: MaterialUpdate,
  },
  {
    ...Material.RawMaterial,
    exact: true,
    component: RawMaterialsList,
  },
  {
    ...Material.RawMaterialFormCreate,
    exact: true,
    component: RawMaterialForm,
  },
  {
    ...Material.RawMaterialFormUpdate,
    exact: true,
    component: RawMaterialForm,
  },
  {
    ...Material.SemiFinishedProduct,
    exact: true,
    component: SemiFinishedProductsList,
  },
  {
    ...Material.SemiFinishedProductFormCreate,
    exact: true,
    component: SemiFinishedProductForm,
  },
  {
    ...Material.SemiFinishedProductFormUpdate,
    exact: true,
    component: SemiFinishedProductForm,
  },
  {
    ...Material.PurchaseSemiFinishedProductsList,
    exact: true,
    component: PurchaseSemiFinishedProductsList,
  },
  {
    ...Material.PurchaseSemiFinishedProductCreate,
    exact: true,
    component: PurchaseSemiFinishedProductForm,
  },
  {
    ...Material.PurchaseSemiFinishedProductUpdate,
    exact: true,
    component: PurchaseSemiFinishedProductForm,
  },
  //#endregion

  //#region Hàng hóa
  {
    ...HangHoa.Industry,
    exact: true,
    component: NganhHangHoa,
  },
  {
    ...HangHoa.Group,
    exact: true,
    component: NhomHangHoa,
  },
  {
    ...HangHoa.DeXuatMatHang,
    exact: true,
    component: DeXuatMatHang,
  },
  {
    ...HangHoa.MatHang,
    exact: true,
    component: MatHang,
  },
  {
    ...HangHoa.XemChiTietHangHoa,
    exact: true,
    component: XemChiTietHangHoa,
  },
  {
    ...HangHoa.CreateDanhMucHangHoa,
    exact: true,
    component: CreateDanhMucHangHoa,
  },
  {
    ...HangHoa.UpdateDanhMucHangHoa,
    exact: true,
    component: UpdateDanhMucHangHoa,
  },
  {
    ...HangHoa.DeXuatGiaHangHoa,
    exact: true,
    component: DeXuatGiaMatHang,
  },
  {
    ...HangHoa.XemDeXuatHangHoa,
    exact: true,
    component: XemDeXuatHangHoa,
  },
  {
    ...HangHoa.DieuChinhGiaHangHoa,
    exact: true,
    component: DieuChinhGiaHangHoa,
  },
  {
    ...HangHoa.DieuChinhThongTinHangHoa,
    exact: true,
    component: DieuChinhThongTinHangHoa,
  },
  {
    ...HangHoa.DieuChinhDinhMucHangHoa,
    exact: true,
    component: DieuChinhDinhMucHangHoa,
  },
  {
    ...HangHoa.BaoCaoDieuChinhGia,
    exact: true,
    component: BaoCaoDieuChinhGia,
  },
  {
    ...HangHoa.BaoCaoDieuChinhDinhMuc,
    exact: true,
    component: BaoCaoDieuChinhDinhMuc,
  },
  //#endregion

  //#region Menu
  {
    ...Menu.DanhSachMenu,
    exact: true,
    component: DanhSachMenuPage,
  },
  {
    ...Menu.TaoMenu,
    exact: true,
    component: TaoMenuPage,
  },
  {
    ...Menu.SuaMenu,
    exact: true,
    component: SuaMenuPage,
  },
  {
    ...Menu.ChiTietMenu,
    exact: true,
    component: ChiTietMenu,
  },
  //#endregion

  //#region Phân quyền
  {
    ...Permission.Group,
    exact: true,
    component: GroupPermission,
  },
  {
    ...Permission.Slip,
    exact: true,
    component: SlipPermission,
  },
  {
    ...Permission.Configuration,
    exact: true,
    component: ConfigurationPermission,
  },
  {
    ...Permission.ApprovalConfiguration,
    exact: true,
    component: ApprovalConfiguration,
  },
  {
    ...Permission.ExportedMaterialConfig,
    exact: true,
    component: ExportedMaterialConfig,
  },
  //#endregion

  //#region Đề xuất nhà cung cấp
  {
    ...DeXuatNhaCungCap.DanhSachDeXuatNhaCungCap,
    exact: true,
    component: DanhSachDeXuatNhaCungCap,
  },
  {
    ...DeXuatNhaCungCap.PhieuDeXuatNhaCungCap,
    exact: true,
    component: PhieuDeXuatNhaCungCap,
  },
  {
    ...DeXuatNhaCungCap.SuaPhieuDeXuatNhaCungCap,
    exact: true,
    component: PhieuDeXuatNhaCungCap,
  },
  {
    ...DeXuatNhaCungCap.DanhGiaDeXuatNhaCungCap,
    exact: true,
    component: DanhGiaDeXuatNhaCungCap,
  },
  {
    ...DeXuatNhaCungCap.ChamDiemDeXuatNhaCungCap,
    exact: true,
    component: ChamDiemDeXuatNhaCungCap,
  },
  //#endregion

  //#region Nhà cung cấp
  {
    ...NhaCungCap.DanhSachPhieuChamDiemNhaCungCap,
    exact: true,
    component: DanhSachPhieuChamDiemNhaCungCap,
  },
  {
    ...NhaCungCap.ThemPhieuChamDiemNhaCungCap,
    exact: true,
    component: PhieuChamDiemNhaCungCap,
  },
  {
    ...NhaCungCap.SuaPhieuChamDiemNhaCungCap,
    exact: true,
    component: PhieuChamDiemNhaCungCap,
  },
  {
    ...NhaCungCap.DanhSachNhaCungCapChamDiem,
    exact: true,
    component: DanhSachNhaCungCapChamDiem,
  },
  {
    ...NhaCungCap.ChamDiemNhaCungCap,
    exact: true,
    component: NhaCungCapChamDiem,
  },
  {
    ...NhaCungCap.DanhSachNhaCungCap,
    exact: true,
    component: DanhSachNhaCungCap,
  },
  //#endregion

  //#region Chất lượng hàng hóa
  {
    ...ChatLuongHangHoa.DanhSachPhieuChamDiemHangHoa,
    exact: true,
    component: DanhSachPhieuChamDiemHangHoa,
  },
  {
    ...ChatLuongHangHoa.ThemPhieuChamDiemHangHoa,
    exact: true,
    component: ThemPhieuChamDiemHangHoa,
  },
  {
    ...ChatLuongHangHoa.SuaPhieuChamDiemHangHoa,
    exact: true,
    component: SuaPhieuChamDiemHangHoa,
  },
  {
    ...ChatLuongHangHoa.DanhSachHangHoaChamDiem,
    exact: true,
    component: DanhSachHangHoaChamDiem,
  },
  {
    ...ChatLuongHangHoa.ChamDiemHangHoa,
    exact: true,
    component: HangHoaChamDiem,
  },
  //#endregion

  //#region Combo
  {
    ...Combo.DanhMucComboItem,
    exact: true,
    component: ComboItem,
  },
  {
    ...Combo.ThemDeXuatCombo,
    exact: true,
    component: ThemDeXuatCombo,
  },
  {
    ...Combo.ThemCombo,
    exact: true,
    component: ThemCombo,
  },
  {
    ...Combo.DanhSachDeXuatCombo,
    exact: true,
    component: DanhSachDeXuatCombo,
  },
  {
    ...Combo.ChiTietDeXuatCombo,
    exact: true,
    component: ChiTietDeXuatCombo,
  },
  {
    ...Combo.SuaDeXuatCombo,
    exact: true,
    component: SuaDeXuatCombo,
  },
  {
    ...Combo.DanhSachCombo,
    exact: true,
    component: DanhSachCombo,
  },
  {
    ...Combo.ChiTietCombo,
    exact: true,
    component: ChiTietCombo,
  },
  {
    ...Combo.SuaCombo,
    exact: true,
    component: SuaCombo,
  },
  //#endregion

  //#region Kho
  {
    ...Warehouse.DanhSachKho,
    exact: true,
    component: WarehouseListPage,
  },
  //#endregion
];

export default routes;
//#endregion
